export default "__VITE_ASSET__d1817cf9__"